import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const permissionsApi = createApi({
  reducerPath: 'permissionsApi',
  baseQuery: createBaseQuery('permissions', { timeout: 0 }),
  endpoints: builder => ({
    getPermissions: builder.query({
      query: () => '/',
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useGetPermissionsQuery } = permissionsApi;
